import { Controller } from "@hotwired/stimulus"

// Shows each section only while the select it depends on holds one of its
// values (see CapHelper#cap_dependent_rows). A field inside any hidden
// section is disabled, so it isn't submitted.
export default class extends Controller {
  static targets = ["section"]

  connect() {
    this.update()
  }

  update() {
    for (const section of this.sectionTargets) {
      const select = this.element.querySelector(`[name="${section.dataset.dependsOn}"]`)
      section.hidden = !JSON.parse(section.dataset.values).includes(select.value)
    }
    for (const section of this.sectionTargets) {
      for (const field of section.querySelectorAll("input, select, textarea")) {
        field.disabled = field.closest("[hidden]") !== null
      }
    }
  }
}
